<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Création des <strong>plafonds</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6" style="display:none;">
              <label for="libelle">Libellé </label>
              <b-form-input type="text" v-model="plafonds.libelle" placeholder="Libelle du plafonds" id="libelle"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="Valeur">Valeur (*)</label> 
              <b-form-input type="number" v-model="plafonds.valeur" placeholder="Montant du plafond" id="valeur"></b-form-input>
            </b-col>
          </b-row>
        
          <div slot="footer">
            <span v-if="can('plafond-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()" style="width:103px;height:40px;border-radius:0px;margin-right:2px;" ><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <span><b-button @click="goBack" type="reset" size="sm" variant="danger" style="width:103px;height:40px;border-radius:0px;"><i class="fa fa-ban"></i> Annuler </b-button></span>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>
<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      plafonds:{
            id:'',
            libelle: '',
            valeur: '',
            _method:'PUT'
      }
    }
  },
  methods:{
    goBack() {
      this.$router.go(-1)
    },
    async post(){     
        this.response = await this.$store.dispatch('plafonds/put_plafonds',this.plafonds)
        this.showAlert()
        if (this.response.success) {
          //this.reset()
          //this.$router.push({ path: `/users/entite/create/${this.response.data.id}` }) // -> /user/123
        }else{
          let dictionary = this.response.errors
          console.log(this.response.errors);
          for (var key in dictionary) {
              // check if the property/key is defined in the object itself, not in parent
              if (dictionary.hasOwnProperty(key)) {           
                  console.log(key, dictionary[key]);
              }
          }
        }
    },
    // get_all_entities(){
    //     return this.rows =  store.getters['entity/rows'];
    // },
    async get_all_typesentite(){
      await this.$store.dispatch('entity/get_all_typesentite').then(()=>{
        store.getters['entity/types'].forEach(element => {
          this.options.push({
            value:element.libelle,
            text:element.libelle.toUpperCase()
          })
        });
      })
    },
    reset(){
            this.plafonds.valeur= '',
            this.plafonds.libelle= ''
           
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    countDownChanged (dismissCountDown){
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    async getPlafonds() {
        let response = await this.$store.dispatch('plafonds/get_all_plafonds')
        this.plafonds.id = response.data.id
        this.plafonds.valeur = response.data.valeur
        this.plafonds.libelle = response.data.libelle
    },
  },
  mounted() {
    //this.get_all_entities()
    this.get_all_typesentite()
    this.getPlafonds()
  }
}
</script>
